// Mapping between database enum values (legal terms) and user-friendly labels
export const MEDIATION_AREA_MAPPING = [
  // ✅ ACTIVE - These 6 will be shown in the frontend
  { 
    value: "droit-de-la-famille", 
    label: "Familial",
    description: "Divorce, garde d'enfants, pension alimentaire",
    suggestions: [
      "Nous souhaitons organiser la garde de nos enfants à l'amiable",
      "Nous avons des désaccords sur la pension alimentaire",
      "Nous devons régler le partage des biens suite à une séparation",
      "Nous avons un conflit familial (héritage, succession)",
    ]
  },
  { 
    value: "droit-du-travail", 
    label: "Entreprise / Travail",
    description: "Conflits employeur-employé, licenciements",
    suggestions: [
      "Je suis en désaccord avec mon employeur sur mes conditions de travail",
      "Je conteste un licenciement ou une sanction disciplinaire",
      "Nous avons un conflit entre associés ou partenaires commerciaux",
      "Je souhaite négocier une rupture conventionnelle",
    ]
  },
  { 
    value: "propriétaire-locataire", 
    label: "Bailleur / Locataire",
    description: "Loyers impayés, état des lieux, expulsions",
    suggestions: [
      "J'ai un litige avec mon locataire concernant des loyers impayés",
      "Je conteste l'état des lieux ou la retenue sur caution",
      "Nous avons un désaccord sur les travaux ou l'entretien du logement",
      "Je souhaite trouver un accord avant une procédure d'expulsion",
    ]
  },
  { 
    value: "protection-des-consommateurs", 
    label: "Consommation",
    description: "Litiges commerciaux, garanties, SAV",
    suggestions: [
      "J'ai un litige avec un commerçant sur un produit défectueux",
      "Je conteste une facture ou un service non conforme",
      "J'ai un problème avec une garantie ou un SAV",
      "Je souhaite obtenir un remboursement ou un geste commercial",
    ]
  },
  { 
    value: "droit-des-contrats", 
    label: "Contrats",
    description: "Rupture de contrats, litiges contractuels",
    suggestions: [
      "L'autre partie ne respecte pas ses engagements contractuels",
      "Je souhaite renégocier les termes d'un contrat",
      "Nous avons un désaccord sur l'interprétation d'un contrat",
      "Je cherche un accord suite à une rupture de contrat",
    ]
  },
  { 
    value: "immobilier", 
    label: "Immobilier",
    description: "Ventes, copropriété, construction",
    suggestions: [
      "J'ai un litige avec un voisin (nuisances, limites de propriété)",
      "Je conteste des décisions de copropriété ou des charges",
      "J'ai un problème suite à une vente immobilière (vices cachés)",
      "J'ai un conflit avec un constructeur ou artisan",
    ]
  },
  
  // 🔒 COMMENTED OUT - To be activated later
  // { 
  //   value: "droit-penal", 
  //   label: "Pénal",
  //   description: "Infractions, victimes, réparation"
  // },
  // { 
  //   value: "dommages-corporels", 
  //   label: "Dommages corporels",
  //   description: "Accidents, responsabilité, indemnisation"
  // },
  // { 
  //   value: "immigration", 
  //   label: "Immigration",
  //   description: "Visas, naturalisation, regroupement familial"
  // },
  // { 
  //   value: "droits-civils", 
  //   label: "Droits civils",
  //   description: "Discriminations, libertés publiques"
  // },
  // { 
  //   value: "international", 
  //   label: "International",
  //   description: "Conflits transfrontaliers, commerce international"
  // },
  // { 
  //   value: "médiation-environnementale", 
  //   label: "Environnement",
  //   description: "Nuisances, pollution, aménagement du territoire"
  // },
] as const;

// Helper function to get label from database value
export const getMediationAreaLabel = (value: string): string => {
  const area = MEDIATION_AREA_MAPPING.find(a => a.value === value);
  return area?.label || value;
};

// Helper function to get database value from label
export const getMediationAreaValue = (label: string): string => {
  const area = MEDIATION_AREA_MAPPING.find(a => a.label === label);
  return area?.value || label;
};

// Helper function to get suggestions for a mediation area
export const getMediationAreaSuggestions = (value: string): string[] => {
  const area = MEDIATION_AREA_MAPPING.find(a => a.value === value);
  return area?.suggestions ? [...area.suggestions] : [];
};

// Export only active areas for forms
export const ACTIVE_MEDIATION_AREAS = MEDIATION_AREA_MAPPING.filter(
  area => typeof area === 'object' && 'value' in area
);
